<template>
  <v-autocomplete
    dense
    color="cyan"
    filled
    :id="id"
    :items="timeList"
    v-model="time"
    :placeholder="placeholder"
    solo
    flat
    :disabled="disabled"
    :readonly="readonly"
    item-color="cyan"
    hide-details
    v-on:change="emitValue()"
  />
</template>

<script>
import moment from "moment-timezone";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  name: "timepicker",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    id: {
      type: String,
      default: "start-time",
    },
    placeholder: {
      type: String,
      default: "Start Time",
    },
    value: {
      type: String,
      default: null,
    },
    minTime: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    minDate: {
      type: String,
      default: moment().format("YYYY-MM-DD"),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value: function () {
      this.init();
    },
    minTime: function () {
      this.emitValue();
      this.initTimeList();
    },
  },
  data() {
    return {
      time: null,
      timeList: [],
    };
  },
  methods: {
    init() {
      this.time = this.value;
      if (this.type == "start-time" || this.type == "end-time") {
        if (Array.isArray(this.timeList)) {
          const exists = this.timeList.some((item) => item.value === this.time);
          if (!exists) {
            this.time = this.type == "start-time" ? "12:00 AM" : "11:45 PM";
            this.emitValue();
          }
        }
      }
    },
    emitValue() {
      this.$emit("input", this.time);
      this.$emit("change", this.time);
    },
    initTimeList() {
      this.timeList = [];
      let startTime = moment().startOf("day");
      let endTime = moment().endOf("day");
      let minTime = this.minTime
        ? moment(`${this.minDate} ${this.minTime}`)
        : null;
      while (startTime.isBefore(endTime)) {
        let value = startTime.add(15, "minutes").format("hh:mm A");
        if (startTime && startTime.isSameOrBefore(minTime)) {
          this.timeList.push({ text: value, value, disabled: true });
        } else {
          this.timeList.push({ text: value, value, disabled: false });
        }
      }
    },
  },
  created() {
    this.initTimeList();
  },
  mounted() {
    this.init();
  },
};
</script>
